import {ModelApi} from '@/api/model.api.js'
import {Channel} from '@/models/channel.model.js'

/**
 * My channels API service
 */
export class MyChannelsApi extends ModelApi {

  //Props
  basePath = '/api/v1/my_channels'
  itemKey = 'channel'
  itemsKey = 'channels'
  ModelClass = Channel
}

//Export singleton instance
export const myChannelsApi = new MyChannelsApi()
